import styled from '@emotion/styled';
import { List } from 'immutable';
import { ClassAttributes, createElement } from 'react';

import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import DummyContent from '../../primitive/DummyContent';
import _DummyOfferDeadlineDisplay from './DummyOfferDeadlineDisplay';
import _DummyOfferStatus from './DummyOfferStatus';

export interface Props {
  className?: string;
}

const DummyOfferDisplay = ({ className }: ClassAttributes<HTMLElement> & Props) => {
  const creationList = List(new Array(3).fill(null)).map((_, index) => {
    return <CreationListItem key={`offer_list_item.creation_list.${index}`} />;
  });

  return (
    <Root className={className}>
      <Wrapper>
        <OfferTitle>
          <OfferJobId />
          <OfferRewardDisplay />
        </OfferTitle>
        <OfferStatus />
        <OfferDeadlineDisplay />
      </Wrapper>

      <CreationListHeading />
      <CreationList>{creationList}</CreationList>
    </Root>
  );
};

const offerDisplayBgColorLight = '#F7F9FD';
const offerDisplayBgColorDark = '#E2E6EF';

const Root = styled('div')({
  padding: SPACING_REGULAR,
});

const Wrapper = styled('div')({
  ...gridLayoutContainer({
    areas: [
      ['offerTitle', 'offerStatus', 'deadline', '.'],
      ['creationList', 'creationList', 'creationList', 'creationList'],
    ],
    rows: ['auto', 'auto'],
    columns: ['auto', 'auto', 'offer', '1fr'],
    justifyContent: 'start',
    alignItems: 'center',
  }),
  marginBottom: SPACING_UNIT,
});

const OfferTitle = styled('div')({
  ...gridLayoutItem('offerTitle'),
  ...gridLayoutContainer({
    areas: [['jobId', 'reward']],
    rows: ['auto'],
    columns: ['auto', 'auto'],
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
  backgroundColor: offerDisplayBgColorLight,
  height: '100%',
  padding: `${SPACING_UNIT}px ${SPACING_REGULAR}px`,
});

const OfferJobId = styled(DummyContent)({
  ...gridLayoutItem('jobId'),
  display: 'inline-block',
  marginRight: SPACING_REGULAR * 2,
});

const OfferRewardDisplay = styled(DummyContent)({
  ...gridLayoutItem('reward'),
  display: 'inline-block',
  width: 128,
});

const OfferStatus = styled(_DummyOfferStatus)({
  ...gridLayoutItem('offerStatus'),
  backgroundColor: offerDisplayBgColorLight,
  height: '100%',
  padding: SPACING_UNIT,
  width: 200,
});

const OfferDeadlineDisplay = styled(_DummyOfferDeadlineDisplay)({
  ...gridLayoutItem('deadline'),
  backgroundColor: offerDisplayBgColorDark,
  height: '100%',
  padding: `${SPACING_UNIT}px ${SPACING_REGULAR}px`,
  width: 128,
});

const CreationListHeading = styled(DummyContent)({
  marginBottom: SPACING_UNIT,
});

const CreationList = styled('div')({
  ...gridLayoutItem('creationList'),
});

const CreationListItem = styled(DummyContent)({
  padding: SPACING_UNIT,
  backgroundColor: offerDisplayBgColorLight,
});

export default DummyOfferDisplay;
